// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"InspirationTab_inspirationWrapper___f4kj","product-listing__row":"InspirationTab_product-listing__row__6j0lI","d-block":"InspirationTab_d-block__MRBw6"};